import { FilesListDisplay } from "../../../../Files/shared/FilesListDisplay.js";
import { FieldDisplayRenderWrapper } from "../components/FieldDisplayRenderWrapper.js";
import { useFormBuilderFieldsContext } from "../../../contexts/FormBuilderFieldsContext.js";
import { InternalContentBadge } from "../../../shared/InternalContentBadge.js";
import "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/GPSMedia/Display.tsx
var GPSMediaFieldDisplay = ({ config }) => {
	const { valuesByFieldId } = useFormBuilderFieldsContext();
	const value = valuesByFieldId[config.id];
	if (!value || !value.length) return null;
	return /* @__PURE__ */ jsx(FieldDisplayRenderWrapper, {
		config,
		children: /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(FilesListDisplay, {
			fileUrls: Array.isArray(value) ? value : [value].filter((x) => !!x),
			label: /* @__PURE__ */ jsxs(Fragment$1, { children: [config.internal && /* @__PURE__ */ jsx(InternalContentBadge, {}), config.options.displayLabel] })
		}) })
	});
};
//#endregion
export { GPSMediaFieldDisplay };

//# sourceMappingURL=Display.js.map